import { render, staticRenderFns } from "./MAN904P01.vue?vue&type=template&id=5962322b&"
import script from "./MAN904P01.vue?vue&type=script&lang=js&"
export * from "./MAN904P01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports